<template>
<div style="background: #fff;overflow: auto;height: 100%;">
  <div class="top-img">
    <!-- <img src="@/assets/image/h5/pool_bg.png"> -->
  </div>
  <div style="display:flex;justify-content:center">
     <div class="content column">
    <div style="font-size: 20px;padding-left:30px;padding-top:30px">意向合作基本信息填写</div>
    <el-divider></el-divider>
    <el-form class="form" ref="ruleForm" :model="formData" :rules="rules" label-position="top" size="mini" inline>
      <div class="title">基本信息</div>
      <el-row>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="姓名" prop="name" >
            <el-input :style="'width:'+ inputWidth" v-model="formData.name" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="联系电话1" prop="phone1">
            <el-input :style="'width:'+ inputWidth" v-model="formData.phone1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="联系电话2" prop="phone2">
            <el-input :style="'width:'+ inputWidth" v-model="formData.phone2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="公司名称" prop="corpName" >
            <el-input :style="'width:'+ inputWidth" v-model="formData.corpName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="注册资金(万元)" prop="registerMoney"  >
            <el-input :style="'width:'+ inputWidth" v-model="formData.registerMoney"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="企业类型" prop="supplierType" :rules="[{required: true, message: '企业类型不能为空'}]">
            <el-select :style="'width:'+ inputWidth" v-model="formData.supplierType">
              <el-option
                v-for="item in companyTypeList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="企业所在(注册)城市" prop="cityName">
              <el-select :style="'width:'+ inputWidth" v-model="formData.cityName"  filterable>
                <el-option
                  v-for="item in supplyCityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
          </el-form-item>
          <!-- <el-form-item label="企业所在(注册)城市" prop="cityName">
            <el-input :style="'width:'+ inputWidth" v-model="formData.cityName"></el-input>
          </el-form-item> -->
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="统一社会信用代码" prop="bizCode">
            <el-input :style="'width:'+ inputWidth" v-model="formData.bizCode"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">品类信息</div>
      <template v-for="(type, index) in formData.supplierPoolCategoryList">
        <div v-bind:key="index">
          <div style="margin-bottom: 10px; margin-left: 3px;display:flex;justify-content: space-between">
            <span v-if="index === 0">主营品类信息</span>
            <span v-else>兼营品类{{index}}</span>
            <el-button style="border:none" size="mini" v-if="index>0" @click="onDel(index)"> <span style="color:#02C675">删除</span> </el-button>
          </div>
          <el-row>
            <el-col :xs="24" :sm="24" :lg="8">
              <el-form-item :label="index===0 ? '主营品类': '兼营品类'"
                :prop="`supplierPoolCategoryList[${index}].fCategory`"
                :rules="[{ required: true, message: '一级品类不能为空', trigger: 'blur'}]">
                <el-select :style="'width:'+ inputWidth" v-model="type.fCategory" @change="class1Change(type.fCategory, index)">
                  <el-option
                    v-for="item in class1List"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="对应二级品类（可多选）"
                :prop="`supplierPoolCategoryList[${index}].class2Ids`"
                :rules="[{ required: true, message: '二级品类不能为空', trigger: 'change'}]">
                <el-select :style="'width:'+ inputWidth" v-model="type.class2Ids" multiple>
                  <el-option
                    v-for="item in class2ListObj[index]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="可供货城市（可多选最多5个）"
               :prop="`supplierPoolCategoryList[${index}].supplyCitys`"
                :rules="[{ required: true, message: '供货城市不能为空', trigger: 'change'}]">
                <el-select :style="'width:'+ inputWidth" v-model="type.supplyCitys" multiple filterable @change="cityChange">
                  <el-option
                    v-for="item in supplyCityList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item
                :label="index === 0 ? '主营品牌': '兼营品牌'" :prop="`supplierPoolCategoryList[${index}].mainBrand`"
                :rules="[{ required: !(!type.fCategory || (type.fCategory === 380 || type.fCategory === 372 || type.fCategory === 379)), message: '兼营品牌不能为空', trigger: 'blur' },{ max: 50, message: '长度不可超过50字符' }]"
                >
                <el-input :style="'width:'+ inputWidth" v-model="type.mainBrand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item label="配送方式"
              :prop="`supplierPoolCategoryList[${index}].supplyType`"
              :rules="[{ required: true, message: '配送方式不能为空', trigger: 'change'}]">
                <el-select :style="'width:'+ inputWidth" v-model="type.supplyType">
                  <el-option
                    v-for="item in deliveryTypeList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item
              label="是否具备独立标准加工车间"
              :prop="`supplierPoolCategoryList[${index}].jobShop`"
              :rules="[{ required: !!(type.fCategory && (type.fCategory === 376 || type.fCategory === 1429 || type.fCategory === 373)), message: '加工车间不能为空' , trigger: 'change'}]"
              >
              <el-select :style="'width:'+ inputWidth" v-model="type.jobShop">
                  <el-option
                    v-for="item in jobShopList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="12" :md="8">
              <el-form-item
                label="配送车辆类型（可多选）"
                :prop="`supplierPoolCategoryList[${index}].supplyCars`"
                :rules="[{ required: !!(type.fCategory && (type.fCategory === 376 || type.fCategory === 1429 || type.fCategory === 373)), message: '配送车辆不能为空' , trigger: 'change'}]"
                >
                <el-select :style="'width:'+ inputWidth" v-model="type.supplyCars" multiple>
                    <el-option
                      v-for="item in carTypeList"
                      :key="item.id"
                      :label="item.text"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-form>
    <div class="add-btn" @click="addSubClass" v-if="formData.supplierPoolCategoryList.length < 4">+添加新的兼营品类信息</div>
    <div style="text-align:center"><el-button type="primary" class="submit-btn" @click="submit">提交</el-button></div>
  </div>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'reversePool',
  data: function () {
    // 验证主营品牌的函数
    const checkMainBrand = (rule, value, callback) => {
      console.log('checkMainBrand', value)
      if (value === '' || value === undefined) {
        callback(new Error('品牌不能为空'))
      } else {
        callback()
      }
    }
    // checkJobShop
    const checkJobShop = (rule, value, callback) => {
      console.log('checkJobShop', value)
      if (value === '' || value === undefined) {
        callback(new Error('加工车间不能为空'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        supplierPoolCategoryList: [ {
          poolType: 1,
          mainBrand: null,
          class2Ids: [],
          supplyCitys: []
        } ],
        sourceType: 1 // 标识来源
      },
      class2ListObj: {
        0: [],
        1: [],
        2: [],
        3: []
      },
      // class2List: [],
      inputWidth: '200px',
      rules: {
        // 姓名：自主填写  必须为汉字or英文，50字符
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5A-Za-z]+$/,
            message: '请输入汉字或英文',
            trigger: 'blur'},
          { max: 50, message: '长度不可超过50字符' }],
        // 手机号1：自主填写   11位数字
        phone1: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入合法的手机号', trigger: 'blur' }],
        // 手机号2：自主填写
        phone2: [],
        // 公司名称：自主填写 只能为汉字数字or英文 50字符
        corpName: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5A-Za-z]+$/,
            message: '请输入汉字或英文',
            trigger: 'blur'},
          { max: 50, message: '长度不可超过50字符' }],
        // 注册资金：自主填写 只能为汉字或数字 50字符
        registerMoney: [
          { required: true, message: '注册资金不能为空', trigger: 'blur' },
          { pattern: /^[+]?([1-9]\d*)(\.\d+)?$/,
            message: '请输入大于或等于1的整数或小数',
            trigger: 'blur'},
          { max: 50, message: '长度不可超过50字符' }
        ],
        // 注册城市：自主填写  只能为汉字 50字符
        cityName: [
          { required: true, message: '注册城市不能为空', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5]+$/,
            message: '请输入汉字',
            trigger: 'blur'},
          { max: 20, message: '长度不可超过20字符' }],
        // 信用代码：自主填写 18位数字
        bizCode: [
          { required: true, message: '信用代码不能为空', trigger: 'blur' },
          { pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
            message: '请输入正确的18位信用代码',
            trigger: 'blur'}
        ],
        // 主营品牌
        mainBrand: [
          { max: 50, message: '长度不可超过50字符' },
          { validator: checkMainBrand }
        ],
        jobShop: [
          { validator: checkJobShop }
        ]
      }
    }
  },
  created () {
    this.getClass1()
    this.getSupplyCitys()
  },
  computed: {
    ...mapState('supplierPool', ['class1List', 'supplyCityList', 'jobShopList', 'deliveryTypeList', 'carTypeList', 'companyTypeList'])
  },
  methods: {
    ...mapActions('supplierPool', ['getSupplyCitys', 'submitSupplierInfo', 'getClass1', 'getClass2']),
    addSubClass () {
      this.formData.supplierPoolCategoryList.push({poolType: 2, mainBrand: null, class2Ids: [], supplyCitys: []})
    },
    cityChange (value) {
      if (value && value.length > 5) {
        this.$message({type: 'warn', message: '可供货城市最多选择5个'})
      }
    },
    class1Change (class1, index) {
      if (!class1) {
        return false
      }
      const obj = this.formData.supplierPoolCategoryList[index]
      this.class2ListObj[index] = []
      if (obj) {
        obj.class2Ids = []
        obj.class2Id = []
      }
      this.getClass2({class1Id: class1}).then(res => {
        this.class2ListObj[index] = res
      })
    },
    onDel (index) {
      this.formData.supplierPoolCategoryList.splice(index, 1)
    },
    submit () {
      this.$refs.ruleForm.validate((valid, a, b) => {
        console.log('表单校验', valid)
        if (valid) {
          const payload = JSON.parse(JSON.stringify(this.formData))
          for (let i = 0; i < payload.supplierPoolCategoryList.length; i++) {
            let sideItem = payload.supplierPoolCategoryList[i]
            if (sideItem.supplyCitys && sideItem.supplyCitys.length > 5) {
              this.$message({type: 'error', message: '可供货城市最多选择5个'})
              return false
            }
            sideItem.class2Id = sideItem.class2Ids && sideItem.class2Ids.join(',')
            sideItem.supplyCity = sideItem.supplyCitys && sideItem.supplyCitys.join(',')
            sideItem.supplyCar = sideItem.supplyCars && sideItem.supplyCars.join(',')
          }
          Object.assign(payload, payload.supplierPoolCategoryList[0])
          console.log(JSON.stringify(payload))
          payload.registerMoney = payload.registerMoney * 10000
          this.submitSupplierInfo(payload).then(res => {
            if (res && res.ret === 1) {
              this.$alert('若有合作意向，后续会有专门的采购联系您', '您已完成信息填报', {
                confirmButtonText: '我知道了',
                callback: action => {
                  if (location.href && location.href.indexOf('https://sweb.yunshanmeicai.com') > -1) {
                    location.href = 'https://www.meicai.cn/#/cooperation' // 跳转正式
                  } else {
                    location.href = 'https://meicai.stage.yunshanmeicai.com/#/cooperation' // 跳转测试
                  }
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
  }
  .column {
    // display: flex;
    flex-direction: column;
  }
  .center {
    justify-content: center;
    align-items: center;
  }
  .top-img {
    width: 100%;
    background: url("../../../assets/image/h5/pool_bg.png");
    height: 200px;
    background-size: cover;
    overflow:hidden;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .content {
    display: flex;
    align-items: center;
    width: 60%;
    height: 100%;
    font-family:'PingFangSC-Regular,PingFang SC';
    // padding-top: 30px 20px 0;
    background: #f8fefc;
    .form {
      width: 100%;
      padding: 0 20px 30px;
      background: #f8fefc;
      .el-col-8 {
        display: flex;
        flex-direction: column;
        justify-items: center;
        align-items: center;
      }
    }
    .title{
      font-size:18px;
      font-weight:500;
      color:#383838;
      line-height:19px;
      flex-direction: row;
      display: flex;
      align-items: center;
      padding: 30px 4px;
    }
    .add-btn {
      width: 100%;
      height: 30px;
      border:1px dotted rgba(217,217,217,1);
      font-size:8px;
      font-family:'PingFangSC-Medium,PingFang SC';
      font-weight:500;
      color:rgba(56,56,56,1);
      line-height:30px;
      text-align: center;
      margin-top: 30px;
    }
    .submit-btn {
      margin-top: 30px;
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/supplierPool/pc/info.vue